<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vhsevy/tc-custom/9781504081412.jpg?1730640855472" alt="This image is the cover for the book Sergeant York and the Great War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sergeant York and the Great War
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This memoir chronicles the Tennessee soldier’s journey from conscientious objector to decorated World War I hero.</b></p><p> In the 1941 film <i>Sergeant York</i>, actor Gary Cooper played a real American soldier, Sgt. Alvin C. York, as he served in World War I. The film garnered an Academy Award for Cooper and further notoriety for York, an American hero. </p> This book, <i>Sergeant York and the Great War</i>, chronicles York’s early years in the backwoods of northern Tennessee until he was drafted into the US Army to serve overseas during World War I. Also featured is York’s war diary, detailing life in the trenches.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Skeyhill
      </h2>
      
      <p class="authorDescription body article"><B>Tom Skeyhill</B>, born January 10, 1895 in Victoria, Australia, was a writer, soldier, and lecturer. He was member of the 8th Battalion, Australian Imperial force, until he was blinded in battle by an exploding shell. Following his military career, he began to write poetry.&#160; Skeyhill traveled around the world, reciting his poetry and raising money for the Red Cross Society. After a lecture at Carnegie Hall, Theodore Roosevelt said that he was &rdquo;the finest soldier speaker in the world.&rdquo;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2191f4c4